import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  min-width: 300px;
  gap: 16px;
  display: flex;
  flex-direction: column;

  .ranking-single-item {
    margin-left: 24px;
  }

  .next, .prev {
    top: calc(50% - 16px);
    width: 20px;
    height: 20px;
    z-index: 100;
    
    svg {
      width: 18px;
      height: 12px;
    }

    &.slick-disabled {
      visibility: hidden;
    }
  }

  .slick-slide {
    visibility: hidden;

    &.slick-active {
      visibility: visible;
    }
  }

  .next {
    right: 0;
  }

  .prev {
    left: 0;
  }

  .slick-list {
    padding: 0 16px; 
  }

  .slick-track {
    display: flex;
    align-items: center;
  }
  
  .slick-slider.slick-initialized {
    padding: 0 12px;

    > ul {
      margin-top: 16px;
    }
  }

  @media (${breakpoint.lgMin}) {
    padding: 16px 16px 10px 16px;

    .next {
      right: -24px;
    }

    .slick-track {
      min-width: 100%;
    }
    
    .slick-slide {
      display: flex;
      height: auto;
      align-items: center;
      justify-content: flex-start;
    }
  }
`;

export default Wrapper;
